<script>
import SoundCalling from 'dashboard/assets/audio/calling.mp3';
import SoundRinging from 'dashboard/assets/audio/ring.mp3';
import Draggable from './Draggable.vue';
import Microphone from './icons/Microphone.vue';
import MicrophoneSlash from './icons/MicrophoneSlash.vue';
import VideoIcon from './icons/Video.vue';
import PhoneSlash from './icons/PhoneSlash.vue';
import NumpadVue from './icons/Numpad.vue';
import PhoneTransfer from './icons/PhoneTransfer.vue';
import Phone from './icons/Phone.vue';
import { mapGetters } from 'vuex';
import parsePhoneNumber from 'libphonenumber-js';
import Avatar from 'next/avatar/Avatar.vue';

export default {
  components: {
    Draggable,
    Microphone,
    VideoIcon,
    MicrophoneSlash,
    Phone,
    PhoneSlash,
    NumpadVue,
    PhoneTransfer,
    Avatar,
  },
  props: {},
  data() {
    return {
      elapsedTime: 0,
      timer: null,
      isMuted: false,
      callingSound: null,
      ringSound: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'softphone/getUIFlags',
      callInfo: 'softphone/getCallInfo',
      inboxes: 'inboxes/getInboxes',
      wavoip: 'softphone/getWavoip',
    }),
    username() {
      return this.callInfo.tag ?? this.callInfo.phone ?? '';
    },
    isCallEndDisabled() {
      return [
        'terminate',
        'reject',
        'accept_elsewhere',
        'reject_elsewhere',
      ].includes(this.callInfo.status);
    },
    formattedDuration() {
      const minutes = Math.floor(this.elapsedTime / 60);
      const seconds = this.elapsedTime % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0'
      )}`;
    },
    // NOVO: Verificar se pode mutar (tem nova API)
    canUseMuteAPI() {
      return this.callInfo.callObject && 
             typeof this.callInfo.callObject.mute === 'function' &&
             typeof this.callInfo.callObject.unmute === 'function';
    },
  },
  watch: {
    inboxes(newInboxes) {
      newInboxes.forEach(inbox => {
        // MELHORADO: Verificar múltiplos campos de token
        const token = inbox.external_token || 
                     inbox.wavoip_token || 
                     inbox.auto_assignment_config?.wavoip_token;
        
        if (token) {
          // console.log('Webphone: Auto-inicializando Wavoip para inbox:', {
          //   name: inbox.name,
          //   token: token.substring(0, 8) + '...',
          //   source: inbox.external_token ? 'external_token' : 
          //          inbox.wavoip_token ? 'wavoip_token' : 'auto_assignment_config'
          // });
          this.startWavoip(inbox.name, token);
        }
      });
    },
    callInfo(newCallInfo) {
      //MELHORADO: Socket listeners mais robustos
      //let instances = this.$store.state.webphone.wavoip;
      let instances = this.$store.state.softphone.wavoip;
      Object.keys(instances).forEach(token => {
        this.listernSockets(token, instances[token].whatsapp_instance);
      });
      
      const status = newCallInfo.status;
      
      // Timer management
      if (status === 'accept') {
        this.startTimer();
      } else if (status === 'terminate') {
        this.stopTimer();
      }
      
      // Sound management
      if (status === 'outcoming_calling') {
        this.playCalling();
      } else {
        this.stopCalling();
      }
      
      if (status === 'offer') {
        this.playRinging();
      } else {
        this.stopRinging();
      }

      // NOVO: Log para debug
      // console.log('📞 Webphone: Status da chamada mudou:', {
      //   status,
      //   hasCallObject: !!newCallInfo.callObject,
      //   canUseMuteAPI: this.canUseMuteAPI
      // });
    },
    wavoip(newWavoip) {
      Object.keys(newWavoip).forEach(token => {
        this.listernSockets(token, newWavoip[token].whatsapp_instance);
      });
    },
  },
  mounted() {
    // console.log('📱 Webphone: Componente montado');
    // Auto-inicializar se já houver inboxes carregados
    if (this.inboxes && this.inboxes.length > 0) {
      this.inboxes.forEach(inbox => {
        const token = inbox.external_token || 
                     inbox.wavoip_token || 
                     inbox.auto_assignment_config?.wavoip_token;
        if (token) {
          this.startWavoip(inbox.name, token);
        }
      });
    }
  },
  methods: {
    startWavoip(inboxName, token) {
      this.$store.dispatch('softphone/startWavoip', {
        token,
        inboxName,
      });
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      //const startDate = this.$store.state.webphone.call.active_start_date;
      const startDate = this.$store.state.softphone.call.active_start_date;
      this.timer = setInterval(() => {
        const now = new Date();
        this.elapsedTime = Math.floor((now - startDate) / 1000);
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.elapsedTime = 0;
    },
    closeSoftphone() {
      this.$store.dispatch('softphone/updateSoftphoneVisible', {
        isOpen: false,
      });
    },
    acceptCall() {
      this.$store.dispatch('softphone/acceptCall');
    },
    rejectCall() {
      this.$store.dispatch('softphone/rejectCall');
    },
    endCall() {
      this.$store.dispatch('softphone/endCall');
    },
    
    // MELHORADO: Métodos de mute com nova API
    async mute() {
      // console.log('Webphone: Tentando mutar chamada');
      
      if (this.canUseMuteAPI) {
        // Usar nova API se disponível
        try {
          await this.$store.dispatch('softphone/muteCall');
          this.isMuted = true;
          // console.log('Webphone: Chamada mutada via nova API');
        } catch (error) {
          // console.error('Webphone: Erro ao mutar via nova API:', error);
          // Fallback para estado local
          this.isMuted = true;
        }
      } else {
        // Fallback para estado local
        // console.log('Webphone: Usando mute local (nova API não disponível)');
        this.isMuted = true;
      }
    },
    
    async unMute() {
      // console.log('🔊 Webphone: Tentando desmutar chamada');
      
      if (this.canUseMuteAPI) {
        // Usar nova API se disponível
        try {
          await this.$store.dispatch('softphone/unmuteCall');
          this.isMuted = false;
          // console.log(' Webphone: Chamada desmutada via nova API');
        } catch (error) {
          // console.error(' Webphone: Erro ao desmutar via nova API:', error);
          // Fallback para estado local
          this.isMuted = false;
        }
      } else {
        // Fallback para estado local
        // console.log('Webphone: Usando unmute local (nova API não disponível)');
        this.isMuted = false;
      }
    },
    
    // MELHORADO: Socket listeners com tratamento de erro
    listernSockets(token, whatsapp_instance) {
      if (!whatsapp_instance || !whatsapp_instance.socket) {
        // console.warn('⚠️ Webphone: Socket não disponível para token:', token);
        return;
      }

      try {
        whatsapp_instance.socket.off('signaling');
        whatsapp_instance.socket.on('signaling', (...args) => {
          const data = args[0];
          // console.log('Webphone: Sinal recebido:', data?.tag);
          
          this.$store.dispatch('softphone/updateCallStatus', data?.tag);
          
          if (data?.tag === 'offer') {
            const name = data?.content?.from_tag;
            const whatsapp_id = data?.content?.phone;
            const phone =
              parsePhoneNumber(`+${whatsapp_id}`)?.formatInternational() ??
              whatsapp_id;
            const profile_picture = data?.content?.profile_picture;
            
            this.$store.dispatch('softphone/incomingCall', {
              token: token,
              phone: phone,
              contact_name: name,
              profile_picture: profile_picture,
            });
          } else if (data?.tag === 'terminate') {
            setTimeout(() => {
              this.$store.dispatch('softphone/resetCall');
            }, 3500);
          } else if (data?.tag === 'reject') {
            setTimeout(() => {
              this.$store.dispatch('softphone/resetCall');
            }, 3500);
          } else if (data?.tag === 'accept_elsewhere') {
            setTimeout(() => {
              this.$store.dispatch('softphone/resetCall');
            }, 3500);
          } else if (data?.tag === 'reject_elsewhere') {
            setTimeout(() => {
              this.$store.dispatch('softphone/resetCall');
            }, 3500);
          }
        });
      } catch (error) {
        // console.error('Webphone: Erro ao configurar socket listeners:', error);
      }
    },
    
    playCalling() {
      try {
        this.callingSound = new Audio(SoundCalling);
        this.callingSound.loop = true;
        this.callingSound.play().catch(e => {
          // console.warn('Webphone: Não foi possível reproduzir som de chamada:', e);
        });
      } catch (error) {
        // console.error('Webphone: Erro ao reproduzir som de chamada:', error);
      }
    },
    
    stopCalling() {
      if (this.callingSound) {
        this.callingSound.pause();
        this.callingSound.currentTime = 0;
      }
    },
    
    playRinging() {
      try {
        this.ringSound = new Audio(SoundRinging);
        this.ringSound.loop = true;
        this.ringSound.play().catch(e => {
          // console.warn('Webphone: Não foi possível reproduzir som de toque:', e);
        });
      } catch (error) {
        // console.error('Webphone: Erro ao reproduzir som de toque:', error);
      }
    },
    
    stopRinging() {
      if (this.ringSound) {
        this.ringSound.pause();
        this.ringSound.currentTime = 0;
      }
    },
  },
  
  // NOVO: Cleanup ao destruir componente
  beforeUnmount() {
    // console.log('Webphone: Limpando recursos...');
    this.stopTimer();
    this.stopCalling();
    this.stopRinging();
  },
};
</script>

<template>
  <Draggable :initial-x="50" :initial-y="50">
    <div
      v-if="uiFlags.isOpen && callInfo.id && callInfo.status !== 'offer'"
      class="flex flex-col h-[315px] w-[250px] bg-white dark:bg-slate-900 opacity-90 border border-gray-500 rounded-xl select-none cursor-grab"
    >
      <div class="flex h-[30px] place-content-between items-center">
        <p class="text-xs text-slate-800 dark:text-slate-100 m-0 px-4">
          {{ callInfo.inbox_name }}
        </p>

        <button
          class="relative m-0 px-4 select-none rounded-lg bg-gray-900 text-center align-middle font-sans text-xs font-medium uppercase text-white transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
          data-ripple-light="true"
          @click="closeSoftphone"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <fluent-icon
              icon="dismiss"
              size="14px"
              class="text-slate-800 dark:text-slate-100"
            />
          </span>
        </button>
      </div>
      <div class="flex justify-center align-middle mt-2">
        <Avatar
          :src="callInfo.picture_profile"
          :name="username"
          status="online"
          :size="64"
          show-status-always
          rounded-full
        />
      </div>
      <div class="flex flex-col my-6">
        <p
          v-if="callInfo.tag"
          class="text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ callInfo.tag }}
        </p>
        <p v-else class="text-slate-800 dark:text-slate-100 m-0 text-center">
          {{ callInfo.phone }}
        </p>

        <p
          v-if="callInfo.status === 'accept'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ formattedDuration }}
        </p>
        <p
          v-if="callInfo.status === 'accept_elsewhere'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.ACCEPT_ELSEWHERE') }}
        </p>
        <p
          v-if="callInfo.status === 'reject_elsewhere'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.REJECT_ELSEWHERE') }}
        </p>
        <p
          v-if="callInfo.status === 'terminate'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.TERMINATE') }}
        </p>
        <p
          v-if="callInfo.status === 'reject'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.TERMINATE') }}
        </p>
        <p
          v-if="callInfo.status === 'outcoming_calling'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CONNECT_CALLING') }}
        </p>
        <p
          v-if="callInfo.status === 'preaccept'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CALLING') }}
        </p>
        <p
          v-if="callInfo.status === 'relaylatency'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CALLING') }}
        </p>
      </div>
      <div class="flex justify-center align-center gap-x-5 my-2">
        <span
          v-if="!isMuted"
          v-tooltip="$t('SOFTPHONE.MUTE')"
          class="cursor-pointer text-slate-800 dark:text-slate-100 hover:text-slate-700 dark:hover:text-slate-300"
          @click="mute"
        >
          <Microphone :size="20" color="currentColor" />
        </span>
        <span
          v-else
          v-tooltip="$t('SOFTPHONE.UNMUTE')"
          class="cursor-pointer text-red-300 hover:text-red-500"
          @click="unMute"
        >
          <MicrophoneSlash :size="20" color="currentColor" />
        </span>
        <span
          v-tooltip="$t('SOFTPHONE.TURN_ON_VIDEO')"
          class="cursor-no-drop text-slate-600 dark:text-slate-300"
          :disabled="false"
        >
          <VideoIcon :size="20" color="currentColor" />
        </span>
        <span
          v-tooltip="$t('SOFTPHONE.NUMPAD')"
          class="cursor-no-drop text-slate-600 dark:text-slate-300"
        >
          <NumpadVue :size="20" color="currentColor" />
        </span>
        <span
          v-tooltip="$t('SOFTPHONE.TRANSFER')"
          class="cursor-no-drop text-slate-600 dark:text-slate-300"
        >
          <PhoneTransfer :size="20" color="currentColor" />
        </span>
      </div>
      <div class="flex justify-center align-center my-4">
        <button
          class="relative h-15 max-h-[30px] w-15 max-w-[30px] p-[17px] select-none rounded-full bg-red-500 text-center align-middle font-sans text-xs font-medium uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
          data-ripple-light="true"
          :disabled="isCallEndDisabled"
          @click="endCall"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <PhoneSlash :size="15" color="white" />
          </span>
        </button>
      </div>
    </div>
    <div
      v-if="uiFlags.isOpen && callInfo.id && callInfo.status === 'offer'"
      class="flex flex-col h-[315px] w-[250px] bg-white dark:bg-slate-900 opacity-90 border border-gray-500 rounded-xl select-none cursor-grab"
    >
      <div class="flex h-[30px] place-content-between items-center">
        <p class="text-xs text-slate-800 dark:text-slate-100 m-0 px-4">
          {{ callInfo.inbox_name }}
        </p>

        <button
          class="relative m-0 px-4 select-none rounded-lg bg-gray-900 text-center align-middle font-sans text-xs font-medium uppercase text-white transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
          data-ripple-light="true"
          @click="closeSoftphone"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <fluent-icon
              icon="dismiss"
              size="14px"
              class="text-slate-800 dark:text-slate-100"
            />
          </span>
        </button>
      </div>
      <div class="flex justify-center align-middle mt-2">
        <Avatar
          :src="callInfo.picture_profile"
          :name="username"
          status="online"
          :size="64"
          show-status-always
          rounded-full
        />
      </div>
      <div class="flex flex-col my-6">
        <p
          v-if="callInfo.tag"
          class="text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ callInfo.tag }}
        </p>
        <p v-else class="text-slate-800 dark:text-slate-100 m-0 text-center">
          {{ $t('SOFTPHONE.UNKNOWN') }}
        </p>

        <p
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ callInfo.phone }}
        </p>
        <p
          v-if="callInfo.status === 'terminate'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.TERMINATE') }}
        </p>
        <p
          v-if="callInfo.status === 'reject'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.TERMINATE') }}
        </p>
        <p
          v-if="callInfo.status === 'outcoming_calling'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CONNECT_CALLING') }}
        </p>
        <p
          v-if="callInfo.status === 'preaccept'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CALLING') }}
        </p>
        <p
          v-if="callInfo.status === 'relaylatency'"
          class="text-lg font-medium text-slate-800 dark:text-slate-100 m-0 text-center"
        >
          {{ $t('SOFTPHONE.CALLING') }}
        </p>
      </div>
      <div class="flex justify-center align-center my-4 gap-x-4">
        <button
          class="relative h-15 max-h-[30px] w-15 max-w-[30px] p-[17px] select-none rounded-full bg-green-500 text-center align-middle font-sans text-xs font-medium uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
          data-ripple-light="true"
          :disabled="isCallEndDisabled"
          @click="acceptCall"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <Phone :size="15" color="white" />
          </span>
        </button>
        <button
          class="relative h-15 max-h-[30px] w-15 max-w-[30px] p-[17px] select-none rounded-full bg-red-500 text-center align-middle font-sans text-xs font-medium uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
          data-ripple-light="true"
          :disabled="isCallEndDisabled"
          @click="rejectCall"
        >
          <span
            class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          >
            <PhoneSlash :size="15" color="white" />
          </span>
        </button>
      </div>
    </div>
  </Draggable>
</template>